import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Button, Form, Input, Card, Typography, notification, message,Select,Modal} from 'antd';
import { CodeOutlined } from '@ant-design/icons';

const { Title } = Typography;

const loginCard = {
    marginTop: 5
};


const failureNotification = () => {
    const args = {
        message: 'Service Unavailable',
        description:
            'We are very sorry that we are unable to serve you at this moment. Please try after some time.',
        duration: 0,
        type: 'error',
    };
    notification.open(args);
};

const ErrorNotification = (args) => {
   
    notification.open(args);
};


class SignIn extends Component {
    
    state = {
        isOtpModalVisible: false, // Track OTP modal visibility
        isLoading: false, // Track loading state
        otp: '', // OTP input value
        email: '', // Store email
        password: '', // Store password
        role: '', //
    };
    changePassword = () => {
        const params = { parentKey: "login" };
        this.props.appStore.currentComponent = { label: "Change Password", key: "passwordReset", params: params };
    }

    registration = () => {
        const params = { parentKey: "login" };
        this.props.appStore.currentComponent = { label: "Registration", key: "registration", params: params };
    };

    render() {
        const store = this.props.appStore;

        return (
            <>
                <Card style={loginCard} title={<Title level={4}>Login</Title>}>
                    <Form layout="vertical" ref={this.formRef} onFinish={this.onFinish} >

                        <Form.Item name="email"
                            rules={[{ required: true, message: 'Please enter your registered email id.' }]}
                            label="EMAIL">
                            <Input />
                        </Form.Item>

                        <Form.Item name="password"
                            rules={[{ required: true, message: 'Please provide your password.' }]}
                            label="PASSWORD">
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            name="role"
                            label="Role"
                            rules={[{ required: true, message: 'Please select Role' }]}
                        >
                            <Select placeholder="Select Role">
                                <Select.Option value="2">MD</Select.Option>
                                <Select.Option value="8">Accounts</Select.Option>
                                {/* Add more roles as needed */}
                            </Select>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" disabled={store.isLoading}>LOGIN</Button>
                        </Form.Item>



                    </Form>

                    <div style={{ textAlign: 'right' }}>
                        <Button style={{ color: "blue" }} type="link" disabled={store.isLoading} onClick={this.changePassword} >Change Password</Button>
                    </div>

                </Card>

                <div style={{ textAlign: 'center', marginTop: 10, marginBottom: 5 }}>
                    <Button style={{ color: "blue" }} disabled={store.isLoading} onClick={this.registration} icon={<CodeOutlined />} >DON'T HAVE AN ACCOUNT?&nbsp;&nbsp;REGISTER HERE.</Button>
                </div>
                  {/* OTP Modal */}
                  <Modal
                    title="Enter OTP"
                    visible={this.state.isOtpModalVisible}
                    onOk={this.handleOtpSubmit}
                    onCancel={this.handleOtpCancel}
                    confirmLoading={this.state.isLoading}
                >
                    <Form layout="vertical" onFinish={this.handleOtpSubmit}>
                        <Form.Item
                            label="OTP"
                            rules={[{ required: true, message: 'Please enter the OTP.' }]}
                        >
                            <Input
                                value={this.state.otp}
                                onChange={(e) => this.setState({ otp: e.target.value })}
                                placeholder="Enter OTP"
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        );
    }

    onFinish = async (values) => {
        const store = this.props.appStore;
        this.setState({ isLoading: true });
        this.setState({
            email: values.email,
            password: values.password,
            role: values.role,
        });
        await store.otpauthenticate(values);

        if (store.isError) {
            failureNotification();
        } else if (store.isInvalid) {
            message.warning('Invalid Login Details.');
        } else {
            this.setState({ isOtpModalVisible: true }); // Show OTP modal on successful login
        }

        this.setState({ isLoading: false });
    };

    handleOtpSubmit = async () => {
        const store = this.props.appStore;
        const { email, password, role, otp } = this.state;

        const payload = { email, password, role, otp };
        this.setState({ isLoading: true });
        await store.generateTokenWithotp(payload);
        if (store.state=="invalid") {

            const args = {
                message: 'Service Unavailable',
                description:
                    'Failed to verify OTP',
                duration: 0,
                type: 'error',
            };

            ErrorNotification(args);
            this.setState({ isOtpModalVisible: true });
        } else {
            this.setState({ isOtpModalVisible: false });
        }

        this.setState({ isLoading: false });
    };

    handleOtpCancel = () => {
        this.setState({ isOtpModalVisible: false });
    };
}



export default observer(SignIn)